// extracted by mini-css-extract-plugin
module.exports = {"modalText":"SiteMessageNotifier_modalText__whq53"};